module.exports = __webpack_public_path__ + "static/img/gfsanzhe.646f95b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gfsanzhe.png
// module id = Vpq9
// module chunks = 1